export enum AuthorityBank {
  REGISTER_BANK_ACCOUNT_VIEW_BANK = '1.10.5',
  REGISTER_BANK_ACCOUNT_EDIT = '1.10.4',
  REGISTER_BANK_ACCOUNT_DELETE = '1.10.3',
  REGISTER_BANK_ACCOUNT_ADD = '1.10.2',
  REGISTER_BANK_ACCOUNT_VIEW = '1.10.1',
  REGISTER_BANK_ACCOUNT_REGISTRATION = '1.10',
}
